import React, { useCallback } from "react";
import { Button } from "grommet";
import { FormNext, FormPrevious } from "grommet-icons";

const STEPS_PER_GROUP = 4;

const Sequencer = ({
  sequence,
  setSequence,
  activeStep,
  instrumentName = "pattern",
  maxShiftSteps = 6,
  onShiftLeft = () => {},
  onShiftRight = () => {},
  shiftStepMs = 5,
  shiftStepPx = 5,
  shiftSteps = 0,
}) => {
  const handleChange = useCallback(
    (idx, checked) => {
      const newSequence = [...sequence];
      newSequence[idx] = checked ? 1 : 0;

      requestAnimationFrame(() => {
        setSequence(newSequence);
      });
    },
    [sequence, setSequence]
  );

  const groups = [];
  for (let i = 0; i < sequence.length; i += STEPS_PER_GROUP) {
    groups.push(sequence.slice(i, i + STEPS_PER_GROUP));
  }

  return (
    <div className="sequencer-row">
      <Button
        a11yTitle={`Shift ${instrumentName} earlier by ${shiftStepMs} milliseconds`}
        className="sequence-shift-button"
        disabled={shiftSteps <= -maxShiftSteps}
        icon={<FormPrevious color="rgba(255, 255, 255, 0.48)" />}
        onClick={onShiftLeft}
        plain
      />
      <div className="sequencer-shift-frame">
        <div
          className="sequencer"
          style={{ transform: `translateX(${shiftSteps * shiftStepPx}px)` }}
        >
          {groups.map((group, groupIdx) => (
            <div className="sequencer-group" key={groupIdx}>
              {group.map((step, idx) => {
                const stepIdx = groupIdx * STEPS_PER_GROUP + idx;

                return (
                  <input
                    style={
                      stepIdx === activeStep
                        ? {
                            backgroundColor: "grey",
                            scale: "0.98",
                          }
                        : {}
                    }
                    key={stepIdx}
                    type="checkbox"
                    checked={step === 1}
                    onChange={(e) => handleChange(stepIdx, e.target.checked)}
                  />
                );
              })}
            </div>
          ))}
        </div>
      </div>
      <Button
        a11yTitle={`Shift ${instrumentName} later by ${shiftStepMs} milliseconds`}
        className="sequence-shift-button"
        disabled={shiftSteps >= maxShiftSteps}
        icon={<FormNext color="rgba(255, 255, 255, 0.48)" />}
        onClick={onShiftRight}
        plain
      />
    </div>
  );
};

export default React.memo(Sequencer);
